import { useMemo } from 'react';
import DateRangePickerUi from '../../../DateRangePickerUi/DateRangePickerUi';
import { getDateString } from '../../../../utils/filters/getDateString';
import { FilterData } from '../../../FilterForm/FilterForm';
import { FilterByDate } from '../../../../types/types';

interface IFilterDateProps {
  onChange: (filterData: FilterData) => void;
  filter: FilterByDate;
  filterData?: FilterData;
}

export default function FilterDate({
  filter,
  filterData,
  onChange,
}: IFilterDateProps) {
  const selectedDay = useMemo(() => {
    if (filterData?.values && filterData?.values[0]) {
      return new Date(filterData.values[0]);
    }
  }, [filterData]);

  function handleDaySet(day, namedRange) {
    const dayString: any = day ? getDateString(day) : null;
    onChange({ id: filter.id, values: [dayString], namedRange });
  }

  return (
    <DateRangePickerUi
      from={selectedDay}
      to={selectedDay}
      handleRangeSet={handleDaySet}
      allowRange={false}
      namedRange={filterData?.namedRange}
      defaultValue={filter.defaultValue || null}
      defaultNamedRange={filter.defaultNamedRange || null}
      minValue={filter.minValue ? new Date(filter.minValue) : null}
      maxValue={filter.maxValue ? new Date(filter.maxValue) : null}
    />
  );
}
